class CreateASplide extends HTMLElement {
  constructor() {
    super();
    this.splideElement = this.querySelector(".splide");
    this.bar = this.splideElement?.querySelector(".my-slider-progress-bar");
    this.renderSplide();
  }

  renderSplide() {
    const options = JSON.parse(this.getAttribute("data-splide"));
    if (this.splideElement) {
      const splide = new Splide(this.splideElement, options);
      if (this.bar) {
        splide.on("mounted move", () => {
          const end = splide.Components.Controller.getEnd() + 1;
          const rate = Math.min((splide.index + 1) / end, 1);
          this.bar.style.width = String(100 * rate) + "%";
        });
      }
      splide.mount();
    } else {
      console.error("Splide element not found.");
    }
  }
}

customElements.define("custom-splide", CreateASplide);
